import React from "react"
import PropTypes from "prop-types"
import { graphql, useStaticQuery } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"

import Markdown from "./Markdown"
import Notice from "./Notice"

const Notices = ({ pageId }) => {
  const intl = useIntl()
  const data = useStaticQuery(graphql`
    query {
      allContentfulNotice {
        nodes {
          node_locale
          noticeId
          isCloseable
          text {
            childMarkdownRemark {
              html
            }
          }
          hideOnPages
          isDummy
        }
      }
    }
  `)

  const notices = data.allContentfulNotice.nodes
    .filter((node) => node.isDummy !== true)
    .filter((node) => node.node_locale === intl.locale)

  return (
    <>
      {notices.map((notice) => (
        <Notice
          id={notice.noticeId}
          key={notice.noticeId}
          pageId={pageId}
          hideOnPages={notice.hideOnPages}
          isCloseable={notice.isCloseable}
        >
          <Markdown>{notice.text.childMarkdownRemark.html}</Markdown>
        </Notice>
      ))}
    </>
  )
}

Notices.propTypes = {
  pageId: PropTypes.string.isRequired,
}

export default Notices
